import { Link } from "react-router-dom";
import logo from "../assets/logo-mark.png";
import "./footer.css";

const exploreLinks = [
  { to: "/tours", label: "Tours" },
  { to: "/destinations", label: "Destinations" },
  { to: "/contact", label: "Plan a trip" },
];

const companyLinks = [
  { to: "/about", label: "About" },
  { to: "/contact", label: "Contact" },
];

function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer className="site-footer mt-auto">
      <div className="container py-5">
        <div className="row g-4 g-lg-5">
          <div className="col-lg-5">
            <Link
              to="/"
              className="site-footer__logo-link d-inline-flex align-items-center gap-3 text-decoration-none"
              aria-label="Mirrorkhan Tours home"
            >
              <img
                src={logo}
                alt=""
                className="site-footer__logo"
                width="44"
                height="52"
                decoding="async"
              />
              <span className="site-footer__title">
                Mirrorkhan <em>Tours</em>
              </span>
            </Link>
            <p className="site-footer__blurb mt-3 mb-0">
              Zanzibar stays and Tanzania trips, planned with care from the
              ground up.
            </p>
          </div>

          <div className="col-lg-7">
            <div className="row g-4">
              <div className="col-6 col-md-4">
                <p className="site-footer__heading">Explore</p>
                <ul className="list-unstyled mb-0 site-footer__list">
                  {exploreLinks.map((link) => (
                    <li key={link.label}>
                      <Link to={link.to}>{link.label}</Link>
                    </li>
                  ))}
                </ul>
              </div>

              <div className="col-6 col-md-4">
                <p className="site-footer__heading">Company</p>
                <ul className="list-unstyled mb-0 site-footer__list">
                  {companyLinks.map((link) => (
                    <li key={link.label}>
                      <Link to={link.to}>{link.label}</Link>
                    </li>
                  ))}
                </ul>
              </div>

              <div className="col-12 col-md-4">
                <p className="site-footer__heading">Desk</p>
                <ul className="list-unstyled mb-0 site-footer__list">
                  <li>Zanzibar, Tanzania</li>
                  <li>
                    <a href="mailto:hello@mirrorkhantours.com">
                      hello@mirrorkhantours.com
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="site-footer__base">
        <div className="container py-3">
          <div className="row gy-2 align-items-center">
            <div className="col-md-6">
              <p className="mb-0 site-footer__meta">© {year} Mirrorkhan Tours</p>
            </div>
            <div className="col-md-6 text-md-end">
              <p className="mb-0 site-footer__meta">Zanzibar first, made personal</p>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
